import React from "react";
import { Modal } from "react-blueprint-library";
import "../../../assets/stylesheets/NotificationModal.scss";
import { isSafari } from "../../../common/Functions";

export default function NotificationModal({
  isOpen = false,
  source = "",
  closeModal = () => {},
  exitApplication = () => {},
}) {
  const notificationBodyText =
    source === "PersonalInformation"
      ? "You can not move forward with this application. Please contact your agency for next steps"
      : "You can not move forward in the application without consenting to the consumer report. Please contact your agency for any questions.";
  const notificationHeaderText =
    source === "PersonalInformation"
      ? "Application Error"
      : "Consent required for release of information";
  return (
    <>
      <div>
        <Modal
          id="notificationModal"
          show={isOpen}
          className={isSafari() ? "modal-md safari-only-wrapper" : "modal-md"}
          title=""
        >
          <div className="modal-body">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="modal-header">
                    <h2>{notificationHeaderText}</h2>
                    <div>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close modal dialog"
                        onClick={closeModal}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p id="notificationModalText">{notificationBodyText}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-start">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <button
                      id="notificationModalExit"
                      className="btn btn-primary"
                      variant="primary"
                      onClick={exitApplication}
                    >
                      Exit Application
                    </button>
                    <button
                      id="notificationModalCancel"
                      type="button"
                      className="btn btn-link"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
